import { render, staticRenderFns } from "./SettingUpPortal.vue?vue&type=template&id=17331210&scoped=true"
import script from "./SettingUpPortal.vue?vue&type=script&lang=js"
export * from "./SettingUpPortal.vue?vue&type=script&lang=js"
import style0 from "./SettingUpPortal.vue?vue&type=style&index=0&id=17331210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17331210",
  null
  
)

export default component.exports